module.exports = __webpack_public_path__ + "static/media/01.e28e17da.webp";